import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadAppSettings } from './services/appSettings';

const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);

loadAppSettings()
  .then(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch((err) => {
    console.error(err);
    rootEl.innerHTML = `<div style="font-family:system-ui,sans-serif;padding:24px;max-width:520px;margin:40px auto;border:1px solid #e5e7eb;border-radius:12px;background:#fef2f2;color:#991b1b;">
      <h1 style="font-size:1.1rem;margin:0 0 8px;">Configuration error</h1>
      <p style="margin:0;font-size:14px;line-height:1.5;">${String(err.message || err).replace(/</g, '&lt;')}</p>
      <p style="margin:16px 0 0;font-size:13px;color:#7f1d1d;">Place a valid <code style="background:#fee2e2;padding:2px 6px;border-radius:4px;">appsettings.json</code> next to <code style="background:#fee2e2;padding:2px 6px;border-radius:4px;">index.html</code> (from the <code style="background:#fee2e2;padding:2px 6px;border-radius:4px;">public</code> folder) with <code style="background:#fee2e2;padding:2px 6px;border-radius:4px;">API_BASE_URL</code> set to your API root URL.</p>
    </div>`;
  });

